import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  identifier: z.string().min(1, t('pages.application_posts.components.posts_create_modal.schema.identifier_required')),
  content: z.string().min(1, t('pages.application_posts.components.posts_create_modal.schema.identifier_required')),
  posts_media: z.array(z.any()).min(1, t('pages.application_posts.components.posts_create_modal.schema.posts_media_required')),
  status: z.string().min(1, t('pages.application_posts.components.posts_create_modal.schema.identifier_required')),
  disable_comments: z.boolean(),
  enable_home: z.boolean(),
  team_uuid: z.string().optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
